import { notification } from 'antd';

const openNotification = ({ type = 'success', message, description }) =>
  notification[type]({
    message,
    description,
  });
export default openNotification;
